import ErrorBorder from 'utils/framework/hocs/withErrorBoundary/ErrorBorder/ErrorBorder';

export default ErrorBorder;
